import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect } from "react";
import { useCart } from "@/lib/cart";

export const Route = createFileRoute("/narocilo-uspesno")({
  head: () => ({
    meta: [
      { title: "Naročilo uspešno — kupish.si" },
      {
        name: "description",
        content:
          "Hvala za vaše naročilo na kupish.si. Potrdilo prejmete na e-naslov, ponudniki pa bodo izdelke pripravili in odposlali v dogovorjenem roku.",
      },
      { name: "robots", content: "noindex, follow" },
      { property: "og:type", content: "website" },
      { property: "og:title", content: "Naročilo uspešno — kupish.si" },
      {
        property: "og:description",
        content:
          "Vaše naročilo je potrjeno. Ponudniki so obveščeni in poskrbijo za pripravo ter pošiljanje izdelkov.",
      },
      { property: "og:url", content: "https://kupish.si/narocilo-uspesno" },
    ],
      links: [{ rel: "canonical", href: "https://kupish.si/narocilo-uspesno" }],
  }),
  component: Page,
});

function Page() {
  const { clear } = useCart();
  useEffect(() => { clear(); }, [clear]);
  return (
    <section className="mx-auto max-w-2xl px-6 py-32 text-center">
      <div className="eyebrow">Hvala!</div>
      <h1 className="font-serif text-5xl mt-3">Vaše naročilo je potrjeno</h1>
      <p className="mt-6 text-muted-foreground">
        Potrdilo bo prispelo na vaš e-naslov. Prodajalci so obveščeni o naročilu in
        bodo poskrbeli za pripravo in pošiljanje.
      </p>
      <div className="mt-10 flex gap-4 justify-center">
        <Link to="/izdelki" className="bg-primary text-primary-foreground px-6 py-3 text-sm">Naprej v trgovino</Link>
        <Link to="/dashboard" className="border border-border px-6 py-3 text-sm">Moj račun</Link>
      </div>
    </section>
  );
}
